import {
  applyClientTheme,
  fetchClientConfig,
  GRANDSYSTEM_CLIENT_FALLBACK,
  type ClientConfig,
} from "@/lib/clientConfig";
import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

type ClientConfigContextValue = {
  config: ClientConfig;
  loading: boolean;
};

const ClientConfigContext = createContext<ClientConfigContextValue>({
  config: GRANDSYSTEM_CLIENT_FALLBACK,
  loading: true,
});

export function ClientConfigProvider({ children }: { children: ReactNode }) {
  const [config, setConfig] = useState<ClientConfig>(GRANDSYSTEM_CLIENT_FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const c = await fetchClientConfig();
      if (!cancelled) {
        setConfig(c);
        applyClientTheme(c);
        setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ClientConfigContext.Provider value={{ config, loading }}>
      {children}
    </ClientConfigContext.Provider>
  );
}

export function useClientConfig(): ClientConfigContextValue {
  return useContext(ClientConfigContext);
}
